import type { UseValidateOptions } from "./validation.type";

import { client } from "@/config/client";
import { useModelMutation } from "@/hooks/queries";

export const useValidateModel = (
  model: string,
  id: number,
  options?: UseValidateOptions
) => {
  return useModelMutation<null, null>(model, id, {
    ...(options ?? {}),
    mutationFn: () => client[model].validate(id),
  });
};
